import React from 'react'

/** Common Components */
import Iconify from '../../../../layouts/components/iconify/iconify';
import { DropdownWrapper } from '../../../ui/dropdownwrapper/DropdownWrapper';

const TASK_TYPE_ICON = {
    task: "ic:outline-task-alt",
    bug: "codicon:bug",
};

const getTypeName = (taskTypeId) => (taskTypeId === 1 ? "task" : "bug");

const TaskTypeSelect = ({ task, taskTypeLabel, taskTypeList = [], onChange, onTaskNavigate }) => {

    const typeName = getTypeName(taskTypeLabel);

    return (
        <div className="task-grid-tasktype-dropdown">
            <DropdownWrapper
                direction="right"
                closeOnSelect={true}
                toggleElement={
                    <span className={`tasktype-badge type-${typeName}`} title="Change task type">
                        <Iconify icon={TASK_TYPE_ICON[typeName]} width={14} />
                    </span>
                }
            >
                <div className="task-grid-tasktype-dropdown-container">
                    {taskTypeList?.map((item) => {
                        const itemTypeName = getTypeName(item.value);

                        return (
                            <button
                                type="button"
                                key={item.value}
                                onClick={() => onChange(item)}
                                className={`type-${itemTypeName}`}
                            >
                                <Iconify icon={TASK_TYPE_ICON[itemTypeName]} width={14} />
                                <div className="tasktype-label">{item.label}</div>
                            </button>
                        );
                    })}
                </div>
            </DropdownWrapper>

            <button
                type="button"
                className={`tasktype-id-btn type-${typeName}`}
                title="Open task"
                aria-label={`Open task ${task.taskId}`}
                onClick={() => onTaskNavigate(task)}
            >
                <span className="tasktype-id">{task.taskId}</span>
            </button>
        </div>
    );
}

export default TaskTypeSelect
